import React from "react";
import { Star, ShieldCheck, Award, BookOpen, Users, Sparkles, Clock } from "lucide-react";
import AnimatedCounter from "./AnimatedCounter";
import Countdown from "./Countdown";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";

const ESSE_LOGO_URL = "https://customer-assets.emergentagent.com/job_acdt-hub/artifacts/iau77wq9_ESSE%20STUDI.jpeg";

const BADGES = [
  { icon: ShieldCheck, label: "MIMIT", desc: "Aggregazione" },
  { icon: Award, label: "Legge 4/2013", desc: "Conformità" },
  { icon: BookOpen, label: "E.S.S.E.", desc: "Centro Studi", logo: ESSE_LOGO_URL },
  { icon: Star, label: "Stella 2026", desc: "Riconoscimento" },
  { icon: Sparkles, label: "Pigreco", desc: "Partner Formativo" },
  { icon: Users, label: "Registro Nazionale", desc: "Albo professionale" },
];

const STATS = [
  { end: 20, suffix: "+", label: "Corsi certificati" },
  { end: 15, suffix: "", label: "Partner istituzionali" },
  { end: 100, suffix: "%", label: "Riconoscimento ufficiale" },
];

export default function SocialProof() {
  return (
    <section className="relative py-20 md:py-24 bg-gradient-to-b from-white via-[#f5f7ff] to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        {/* Countdown + Stats Row */}
        <div className="grid lg:grid-cols-12 gap-6 reveal">
          {/* Countdown banner */}
          <div className="lg:col-span-6 relative rounded-2xl bg-gradient-to-br from-[#0a1f55] via-[#102a6b] to-[#1e3a8a] text-white p-6 md:p-7 overflow-hidden">
            <div className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-[#f59e0b]/25 blur-3xl"></div>
            <div className="relative">
              <div className="flex items-center gap-2.5 mb-3">
                <div className="h-9 w-9 rounded-lg bg-[#f59e0b] text-[#0a1f55] flex items-center justify-center">
                  <Clock className="h-4.5 w-4.5" />
                </div>
                <div>
                  <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#fbbf24]">
                    Iscrizioni in chiusura
                  </div>
                  <div className="text-[15px] font-extrabold leading-tight">
                    Corso Consulente Digitale
                  </div>
                </div>
              </div>
              <Countdown variant="dark" />
              <a href="/corso#acquista" className="mt-5 inline-block w-full">
                <Button className="w-full h-11 bg-[#f59e0b] hover:bg-[#d97706] text-[#0a1f55] font-bold">
                  Iscriviti subito al corso
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </a>
            </div>
          </div>

          {/* Stats */}
          <div className="lg:col-span-6 grid grid-cols-3 gap-4">
            {STATS.map((s, i) => (
              <div
                key={s.label}
                className="text-center rounded-2xl border border-slate-200 bg-white p-5 lift flex flex-col justify-center"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="text-3xl md:text-4xl font-extrabold text-[#102a6b] leading-none">
                  <AnimatedCounter end={s.end} suffix={s.suffix} />
                </div>
                <div className="mt-2 text-[11.5px] uppercase tracking-wider text-slate-500 font-semibold leading-tight">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Trust badges marquee */}
        <div className="mt-14 reveal">
          <div className="text-center text-[11px] uppercase tracking-[0.22em] font-bold text-slate-500 mb-6">
            Riconoscimenti & Partner ufficiali
          </div>
          <div className="relative overflow-hidden">
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#f5f7ff] to-transparent z-10"></div>
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#f5f7ff] to-transparent z-10"></div>
            <div className="flex items-center gap-6 marquee-track w-max">
              {[...BADGES, ...BADGES].map((b, i) => {
                const Icon = b.icon;
                return (
                  <div
                    key={`${b.label}-${i}`}
                    className="shrink-0 flex items-center gap-3 px-5 py-3 rounded-xl bg-white border border-slate-200 shadow-sm"
                  >
                    <div className={`h-9 w-9 rounded-lg flex items-center justify-center overflow-hidden ${b.logo ? "bg-white border border-slate-200" : "bg-[#102a6b]/10 text-[#102a6b]"}`}>
                      {b.logo ? (
                        <img src={b.logo} alt={b.label} loading="lazy" className="h-full w-full object-contain" />
                      ) : (
                        <Icon className="h-4.5 w-4.5" />
                      )}
                    </div>
                    <div>
                      <div className="text-[13px] font-bold text-[#0a1f55] leading-none">{b.label}</div>
                      <div className="text-[10.5px] text-slate-500 mt-0.5">{b.desc}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
